import { render, staticRenderFns } from "./CGender.vue?vue&type=template&id=0b345968&scoped=true&"
import script from "./CGender.vue?vue&type=script&lang=js&"
export * from "./CGender.vue?vue&type=script&lang=js&"
import style0 from "./CGender.vue?vue&type=style&index=0&id=0b345968&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b345968",
  null
  
)

export default component.exports